export const keyValuesMatch = <T>(_kv: {[K in keyof T]: K}) => {
  return;
};
